module.exports = __webpack_public_path__ + "static/media/border-all.a23da964.svg";